import Client from "./Client";
// import RequestList from "./RequestList";

const FaxesService = {
    url: 'admin/settlement-requests',
    getDefault(){
        return {
            id : undefined,
            reseller_id : undefined,
            from_date : undefined,
            to_date : undefined,
            settlement_fee : undefined,
            settlement_at : undefined,
            created_at : undefined
        }
    },
    /**
     * @params RequestList requestList
     * @return Request Promise
     **/
    async list(requestList) {
        return await Client.get(`${this.url}`, requestList.json());
    },

    /**
     * @params category
     * @return Request Promise
     **/
    async complete(modelId) {
        return await Client.post(`${this.url}/${modelId}/complete`);
    }
}

export default FaxesService